import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const BarChartIcon = ({ width, height, disabled }: IconProps) => {
  return (
    <BaseIcon
      width={width}
      height={height}
      disabled={disabled}
      viewBox="0 0 15 15"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 14.5C0.447716 14.5 0 14.0523 0 13.5V5.67743C0 5.12515 0.447715 4.67743 1 4.67743H2.27416C2.82644 4.67743 3.27416 5.12515 3.27416 5.67743V13.5C3.27416 14.0523 2.82644 14.5 2.27416 14.5H1ZM6.61292 14.5C6.06064 14.5 5.61292 14.0523 5.61292 13.5V1C5.61292 0.447715 6.06064 0 6.61292 0H7.88708C8.43936 0 8.88708 0.447715 8.88708 1V13.5C8.88708 14.0523 8.43936 14.5 7.88708 14.5H6.61292ZM12.2258 14.5C11.6736 14.5 11.2258 14.0523 11.2258 13.5V9.41938C11.2258 8.8671 11.6736 8.41938 12.2258 8.41938H13.5C14.0523 8.41938 14.5 8.8671 14.5 9.41938V13.5C14.5 14.0523 14.0523 14.5 13.5 14.5H12.2258Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default BarChartIcon;
